import { Box } from "@mui/material";
import { Banner, Details } from "./components";

const Blog = () => {
  return (
    <Box>
      <Banner />
      <Details />
    </Box>
  );
};

export default Blog;
